module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    ref: "okay",
    staticClass: "btn",
    class: _vm.btnClass,
    attrs: {
      "type": "button"
    }
  }, [(_vm.icon) ? _c('icon', {
    attrs: {
      "name": _vm.icon,
      "viewBox": "0 0 24 24"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasSlot) ? _c('span', [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (_vm.label && !_vm.hasSlot) ? _c('span', [_vm._v(_vm._s(_vm.label))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3ef4356","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/Action.vue
// module id = 498
// module chunks = 225